<!-- Sub Sub Menu Context Menu Component -->
<ul class="context-menu-list" style="position: relative" [@menu]="_state" (@menu.done)="_onAnimationDone($event)">
  <li class="context-menu-item" (click)="handleClick('Foo Bar')">Foo Bar</li>
  <li class="context-menu-item" (click)="handleClick('Doe Bar')">Doe Bar</li>
</ul>
<!--/ Sub Sub Menu Context Menu Component -->
